<template>
	<div>
		<div v-if="!isMigrate">
			<vs-row class="mb-4">
				<vs-col class="pr-1" vs-type="flex" vs-justify="flex-start" vs-align="flex-end" vs-w="6">
					<vs-input class="mr-2 w-full" label="Token" placeholder="Ingrese el token" v-model.trim="token"/>
					<vs-button :disabled="token === ''" color="success" type="border" @click="getFormsV1">Success</vs-button>
				</vs-col>
				<vs-col class="pl-1" vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="6">
					<!-- <vs-input class="mr-2 w-1/2" label="" placeholder="Buscar..." v-model.trim="search"/> -->
					 <vs-input icon-pack="feather" icon="icon-search" placeholder="Buscar..." v-model.trim="search" class="is-label-placeholder w-1/2" />
				</vs-col>
			</vs-row>
			<vTable  :data="_listForms" :queryForm="queryForm"></vTable>
		</div>
		
		<vJsonViewer v-if="isMigrate" :oneForm="oneForm" :_isMigrate="_isMigrate" :Group="Group"></vJsonViewer>
	</div>
	
</template>

<script type="text/javascript">
	import JsonEditor from 'vue-json-formatter-editor';
	import { converToFormV2 } from './models/questions.js';

	import Api from '@/helpers/api';
	import vTable from './Table.vue';
	import vJsonViewer from './transformForm.vue';
	

	import FormData from './form-data.js';
	export default {
		components: {
            vJsonViewer, 
			vTable,			
        },
		mounted() {
			this.getGroup();
		},
		data() {
			return {
				token: process.env.VUE_APP_TOKEN,
				listForms: [],
				oneForm: {},
				isMigrate: false,				
				Group: [],
				FormData,
				jsonData: [],				
				convertForm: [],
				search: ''
			}
		},
		
		methods: {
			convertTo() {				
				const data = JSON.parse(this.jsonData);
				const result = converToFormV2(data);			
				this.convertForm = result;			
			},
			_isMigrate() {
				this.isMigrate = !this.isMigrate
			},
			async getFormsV1() {
				try {
					const result = await Api.get('/forms', { uri: 'V1', token: this.token});
					this.listForms = result.data;
					
				} catch (error) {
					console.log('Error ', error)
				}
			},
			async queryForm(idForm, formType) {
				try {
					const result = await Api.get(`/forms/${idForm}/last`, { uri: 'V1', token: this.token});
					this._isMigrate();
					this.oneForm = { ...result.data, formType};					
				} catch (error) {
					console.log('Error ', error)
				}				
			},
			async getGroup() {
				try {
					const result = await Api.get('/groups');
					this.Group = result.data.map(item => {
						return {value: item.key, label: item.name}
					});					
				} catch (error) {
					console.log('Error: group ',error);
				}
			}
		},
		computed: {
			_listForms() {
				return this.listForms.filter(form => {
					if(this.search.toLowerCase() != '') {
						return form.activity.toLowerCase().includes(this.search.toLowerCase())
					}
					
					return true;
				});
			}
		}
	}
</script>

<style type="text/css">
	.editor {
		width: 100%;
		height: 600px;
	}
</style>
